import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';

import { QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { SimpleSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

// TODO: Mave logic shared
const getBackButtonProps = (scope) => {
  const previousRoute = _.get(scope, 'location.state.previousRoute');

  if (previousRoute && previousRoute.includes('campaign/vnext')) {
    const url = new URL(previousRoute);

    return {
      text: undefined,
      pathname: url.pathname,
      search: url.search,
    };
  }

  return {
    text: _TL_('Back to overview'),
    pathname: '/campaign/vnext/overview',
    search: `?uid=${scope.values.uid}&cid=${scope.values.cid}&aid=${scope.values.aid}`,
  };
};

const Loader = (props) => {
  const {
    i18n,
    siteMap,
    scope,
    updateAvailability,
    isVisible,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const { text, pathname, search } = useMemo(() => getBackButtonProps(scope), [scope]);

  const url = `${pathname}${search}`;
  const title = i18n.getString(scope.values.adId ? _TL_('Edit ad') : _TL_('Create ad'));

  useEffect(() => { updateAvailability(!_.isEmpty(selectedParent)); });

  return isVisible
    ? (
      <SimpleSummaryBar
        selectedParent={selectedParent}
        breadCrumbText={title}
        backButtonText={text ? i18n.getString(text) : undefined}
        backButtonUrl={url}
        {...others}
      />)
    : null;
};

Loader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
  isVisible: false,
};

export const AdEditorSummaryBarLoader = React.memo(Loader);
